import Cookies from 'js-cookie';

export const getClientCookieValue = (name: string): string | null => {
    return Cookies.get(name) ?? null;
};